var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 24.75H18.25C18.0375 24.75 17.8594 24.6781 17.7156 24.5343C17.5719 24.3904 17.5 24.2122 17.5 23.9997C17.5 23.7871 17.5719 23.609 17.7156 23.4654C17.8594 23.3218 18.0375 23.25 18.25 23.25H23.25V18.25C23.25 18.0375 23.3219 17.8594 23.4657 17.7156C23.6095 17.5719 23.7877 17.5 24.0003 17.5C24.2129 17.5 24.391 17.5719 24.5346 17.7156C24.6782 17.8594 24.7499 18.0375 24.7499 18.25V23.25H29.75C29.9625 23.25 30.1406 23.3219 30.2843 23.4657C30.4281 23.6095 30.5 23.7877 30.5 24.0003C30.5 24.2129 30.4281 24.391 30.2843 24.5346C30.1406 24.6782 29.9625 24.75 29.75 24.75H24.7499V29.75C24.7499 29.9625 24.678 30.1406 24.5342 30.2843C24.3904 30.4281 24.2122 30.5 23.9997 30.5C23.7871 30.5 23.609 30.4281 23.4654 30.2843C23.3218 30.1406 23.25 29.9625 23.25 29.75V24.75Z",
    fill: "#2E2F32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/addIcon.6422e44e05d771ba340bf71e901962c9.svg";
export { ForwardRef as ReactComponent };